import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const LandingProjectListPage = lazyWithRetry(() =>
  import('./pages/LandingProjectListPage').then((module) => ({
    default: module.LandingProjectListPage,
  }))
)

const LandingPageGeneratorPage = lazyWithRetry(() =>
  import('./pages/LandingPageGeneratorPage').then((module) => ({
    default: module.LandingPageGeneratorPage,
  }))
)

const QuickLandingCreatePage = lazyWithRetry(() =>
  import('./pages/QuickLandingCreatePage').then((module) => ({
    default: module.QuickLandingCreatePage,
  }))
)

const routes: AppRoute[] = [
  {
    path: 'landing-pages',
    children: [
      {
        index: true,
        element: LandingProjectListPage,
        meta: {
          title: 'landingPage.title',
        },
      },
      {
        path: 'new',
        element: LandingPageGeneratorPage,
        meta: {
          title: 'landingPage.wizard.title',
        },
      },
      {
        path: 'quick-create',
        element: QuickLandingCreatePage,
        meta: {
          title: 'landingPage.quickCreate.title',
        },
      },
      {
        path: ':projectId',
        element: LandingPageGeneratorPage,
        meta: {
          title: 'landingPage.wizard.title',
        },
      },
    ],
  },
]

export default routes
